import React from "react";
import { DPRestrictedPage } from "Components/DP";
import { History } from "history";
import { PageNotFound } from "..";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import { ComplianceReportsTabs } from "./ComplianceReportsTabs/ComplianceReportsTabs";
import {
  ComplianceReportPath,
  tabPaths,
  tabLabels,
  complianceReportTabs,
} from "./ComplianceReports";

export interface ComplianceReportsProps {
  title: string;
  tab: ComplianceReportPath;
  history: History;
}

export const ComplianceReports = ({
  title,
  tab,
  history,
}: ComplianceReportsProps) => {
  const { enabledFeatures, permissions } = usePartnerConfig();
  const tabIndex = tabPaths.indexOf(tab);

  const onPageLoad = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.ComplianceReportingPageViewed,
      payload: { tab: tabLabels[tabIndex] },
    });
  };

  const hideComplianceReports =
    enabledFeatures.indexOf("provider_compliance_reports") === -1 ||
    !permissions.canViewComplianceReports;

  if (hideComplianceReports) {
    return <PageNotFound />;
  }

  return (
    <DPRestrictedPage
      title={title}
      permissionKey="canViewReports"
      onPageLoad={onPageLoad}
    >
      <ComplianceReportsTabs
        tabIndex={tabIndex}
        tabLabels={tabLabels}
        handleTabChange={(selectedTabIndex: number) => {
          const selectedTabLabel = tabLabels[selectedTabIndex];
          const newTab = complianceReportTabs.find(
            (tab) => tab.label === selectedTabLabel
          );
          history.push(`./${newTab?.path}`);
        }}
      />
    </DPRestrictedPage>
  );
};
